import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ops-settings-add-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ops-settings-add-button.component.html',
  styleUrl: './ops-settings-add-button.component.scss',
})
export class OpsSettingsAddButtonComponent {
  @Input() label?: string;
  @Input() asWarning?: boolean;
  @Input() fullWidth?: boolean;
  @Input() isDisabled?: boolean;
  @Output() clicked = new EventEmitter<void>();

  onClick(event: any): void {
    this.clicked.emit(event);
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Backspace') {
      // const currentFocusedElement = document.activeElement;
      // // Get all focusable elements
      // const focusableElements = Array.from(
      //   document.querySelectorAll(
      //     'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      //   )
      // ).filter(
      //   (el) =>
      //     !el.hasAttribute('disabled') && el.getAttribute('tabindex') !== '-1'
      // );
      // // Find the index of the currently focused element in the list of focusable elements
      // const currentIndex = focusableElements.indexOf(currentFocusedElement);
      // // Get the previous focusable element, if it exists
      // const previousElement = focusableElements[currentIndex - 1];
      // if (previousElement) {
      //   (previousElement as any).focus();
      // }
      // return;
    }
  }
}
